import * as types from './mutations-types'
import pointsMailApi from '../../../../../api/wx-member/points-mall/points-mall'
import FormatTableFieldUtils from '../../../../../common/utils/format-table-field-util'
import * as DictionaryConstants from '../../../../../constants/DictionaryConstants'
import * as DataTypeConstants from '../../../../../constants/DataTypeConstants'

export default {
  getExchangeRecord: ({commit}, data) => {
    pointsMailApi.getExchangeRecord(data)
      .then(result => {
        let params = [
          {
            fieldDataType: DataTypeConstants.FORMAT_TABLE_DICT,
            fieldPropCode: 'orderStatus',
            fieldPropName: 'orderStatusName',
            fieldFormatParam: DictionaryConstants.ORDER_STATUS
          }
        ]
        FormatTableFieldUtils.formatTableFieldName(result.dataList, params).then(res => {
          result.dataList = res
          commit(types.EXCHANGE_RECORD_LIST, result)
        })
      })
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/exchange-record/store/actions.js